// extracted by mini-css-extract-plugin
module.exports = {"how-works":"HowWorks_how-works__AqawI","hide-mobile":"HowWorks_hide-mobile__W_39I"};